(function(){
  if (window.__spStep3TitlePairInit) return;
  window.__spStep3TitlePairInit = true;

  var EYEBROW_TEXT = 'Your Engagement Ring';
  var FREE_SHIPPING_RX = /free\s+(insured\s+)?shipping/i;

  var SHAPES = [
    'Elongated Hexagon','Antique Cushion','Long Cushion','Old European','Old Mine',
    'Dutch Marquise','French Marquise','Portuguese','Hexagon','Asscher','Princess',
    'Marquise','Cushion','Emerald','Radiant','Round','Oval','Pear','Heart','Moval'
  ];
  var CLARITIES = ['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2','I3'];

  function txt(el){ return el ? (el.textContent||'').replace(/\s+/g,' ').trim() : ''; }
  function find(sel, root){ return (root||document).querySelector(sel); }

  function readDiamond(section){
    var d = { carat:'', shape:'', color:'', clarity:'', type:'' };
    var info = txt(find('.diamond__info', section));

    d.carat   = txt(find('.carat-info', section))   || txt(find('#carat-info', section));
    d.shape   = txt(find('.shape-info', section))   || txt(find('#shape-info', section));
    d.color   = txt(find('#color-info', section))   || txt(find('.color-info', section));
    d.clarity = txt(find('#clarity-info', section)) || txt(find('.clarity-info', section));

    if (info){
      if (/\blab\b/i.test(info)) d.type = 'Lab';
      else if (/\bnatural|mined\b/i.test(info)) d.type = 'Natural';

      if (!d.carat){
        var m = info.match(/(\d+(?:\.\d+)?)\s*(?:ct|carat)/i);
        if (m) d.carat = m[1];
      }
      if (!d.shape){
        for (var i=0;i<SHAPES.length;i++){
          if (new RegExp('\\b'+SHAPES[i].replace(/\s+/g,'\\s+')+'\\b','i').test(info)){
            d.shape = SHAPES[i]; break;
          }
        }
      }
      if (!d.color){
        var c = info.match(/\b(?:Color\s*[:\-]?\s*)?([D-K])\b/);
        if (c) d.color = c[1];
      }
      if (!d.clarity){
        for (var j=0;j<CLARITIES.length;j++){
          if (new RegExp('\\b'+CLARITIES[j]+'\\b').test(info)){ d.clarity = CLARITIES[j]; break; }
        }
      }
    }

    d.carat   = (d.carat||'').replace(/\s*(ct|carat)\s*/i,'').trim();
    d.color   = (d.color||'').trim().toUpperCase();
    d.clarity = (d.clarity||'').trim().toUpperCase();
    d.shape   = (d.shape||'').trim();
    return d;
  }

  function buildDescriptor(d){
    if (!d.carat && !d.shape && !d.color && !d.clarity) return '';
    var parts = [];
    if (d.carat)   parts.push(d.carat + ' Carat');
    if (d.color)   parts.push(d.color);
    if (d.clarity) parts.push(d.clarity);
    if (d.shape)   parts.push(d.shape);
    var noun = (d.type ? d.type + ' Diamond' : 'Diamond');
    return parts.join(' ') + ' ' + noun;
  }

  function applyEyebrow(section){
    var eyebrow = section.querySelector('#collectionTitle')
               || section.querySelector('.product-single__collection');
    if (!eyebrow) return;
    eyebrow.setAttribute('data-sp-eyebrow', 'engagement');
    if (eyebrow.textContent !== EYEBROW_TEXT){
      eyebrow.textContent = EYEBROW_TEXT;
    }
  }

  function applyTitle(section){
    var title = section.querySelector('.product-single__title');
    if (!title) return;

    var d = readDiamond(section);
    var desc = buildDescriptor(d);

    var pair = title.querySelector('.sp-stp-pair');
    if (!desc){
      if (pair) pair.remove();
      return;
    }
    if (!pair){
      pair = document.createElement('span');
      pair.className = 'sp-stp-pair';
      pair.innerHTML = ' with a <span class="sp-stp-pair__desc"></span>';
      title.appendChild(pair);
    }
    var descNode = pair.querySelector('.sp-stp-pair__desc');
    if (descNode && descNode.textContent !== desc){
      descNode.textContent = desc;
    }
  }

  /* Hide any small element whose visible text matches "Free … Shipping".
     Length-bounded so we don't hide a wrapper that just happens to
     contain the phrase deep inside a larger block. */
  function hideFreeShipping(section){
    var nodes = section.querySelectorAll('p, span, div, small, h6');
    for (var i=0; i<nodes.length; i++){
      var node = nodes[i];
      if (node.dataset.spFreeShipHidden === 'true') continue;
      /* Skip our own snippets' nodes. 2026-07-28: added .sp-bn-ship and
         .sp-wte — the step-3 shipping row and the What to Expect band both
         legitimately read "Free insured shipping" and this sweep was blanking
         them. Harmless if either block is ever removed. */
      if (node.closest('.sp-stp-cards, .sp-secondary-ctas, .sp-order-by, .sp-bn-ship, .sp-wte')) continue;
      var t = (node.textContent || '').replace(/\s+/g,' ').trim();
      if (!t || t.length > 80) continue;
      if (FREE_SHIPPING_RX.test(t)){
        node.style.display = 'none';
        node.dataset.spFreeShipHidden = 'true';
      }
    }
  }

  function apply(){
    var section = document.getElementById('finalmainsection');
    if (!section) return;
    applyEyebrow(section);
    applyTitle(section);
    hideFreeShipping(section);
  }

  function watch(){
    var section = document.getElementById('finalmainsection');
    if (!section) return;
    var sources = [
      section.querySelector('#collectionTitle'),
      section.querySelector('.diamond__info'),
      section.querySelector('.carat-info'),
      section.querySelector('.shape-info'),
      section.querySelector('#color-info'),
      section.querySelector('#clarity-info')
    ].filter(Boolean);
    if (!sources.length) return;
    var pending = false;
    var obs = new MutationObserver(function(){
      if (pending) return;
      pending = true;
      requestAnimationFrame(function(){ pending = false; apply(); });
    });
    sources.forEach(function(n){
      obs.observe(n, { childList:true, subtree:true, characterData:true });
    });
  }

  function init(){
    apply();
    watch();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var bootObs = new MutationObserver(function(){
    if (document.getElementById('finalmainsection')) init();
  });
  bootObs.observe(document.body, { childList:true, subtree:true });
  setTimeout(function(){ try { bootObs.disconnect(); } catch(_){} }, 8000);
})();
